module.exports = __webpack_public_path__ + "static/img/2.05434fe.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/1/eng/2.png
// module id = 7v5T
// module chunks = 0